<template>
    <div class="overflow-x-auto shadow mt-4 mb-[3%]">
        <table class="w-full border-[1px] text-left lg:text-xl">
            <thead class="text-white">
                <tr class="border-b-[1px] border-black bg-[#545656] py-2">
                    <th class="w-[8%] font-medium p-3" id="header_ID">ID</th>
                    <th class="w-[30%] font-medium p-3" id="header_Organisation">Organisation</th>
                    <th class="w-[16%] font-medium p-3" id="header_Name">Name</th>
                    <th class="w-[16%] font-medium p-3" id="header_Vorname">Vorname</th>
                    <th
                        v-if="hasUpdateContactLink || selectMethod"
                        class="w-[10%] font-medium p-3 text-center"
                        id="header_Bearbeiten"
                    >
                        Bearbeiten
                    </th>
                    <th
                        v-if="hasCreateContactLink"
                        id="header_Duplizieren"
                        class="w-[10%] font-medium p-3 text-center"
                    >
                        Duplizieren
                    </th>
                    <th
                        v-if="hasDeleteContactLink"
                        id="header_Löschen"
                        class="w-[10%] font-medium p-3 text-center"
                    >
                        Löschen
                    </th>
                </tr>
            </thead>
            <tbody id="contacts_body">
                <tr
                    class="border-b-2"
                    v-for="contact in contacts?.slice(0, contactsCount)"
                    v-bind:key="String(contact.contactId)"
                    data-cy="contact-row"
                >
                    <td class="w-[8%] font-medium p-3" id="body_ID">
                        {{ contact.contactId }}
                    </td>
                    <td class="w-[30%] font-medium p-3" id="body_Organisation">
                        {{ contact.organisation?.name }}
                    </td>
                    <td class="w-[16%] font-medium p-3" id="body_Name">
                        {{ contact.person?.familyName }}
                    </td>
                    <td class="w-[16%] font-medium p-3" id="body_Vorname">
                        {{ contact.person?.firstName }}
                    </td>
                    <td
                        v-if="hasUpdateContactLink || selectMethod"
                        class="w-[10%] font-medium p-3"
                        id="body_Bearbeiten"
                    >
                        <button
                            @click="props.selectMethod?.(contact)"
                            class="w-full"
                            data-cy="update_button"
                        >
                            <img
                                src="@/assets/images/Arrow_right.png"
                                alt="Open"
                                class="lg:w-[35px] w-[20px] mx-auto"
                            />
                        </button>
                    </td>
                    <td
                        v-if="hasCreateContactLink"
                        class="w-[10%] font-medium p-3"
                        id="body_Duplizieren"
                    >
                        <button
                            @click="props.duplicateMethod?.(contact)"
                            class="w-full"
                            data-cy="duplicate_button"
                        >
                            <img
                                src="@/assets/images/Duplizieren.png"
                                alt="Open"
                                class="lg:w-[35px] w-[20px] mx-auto"
                            />
                        </button>
                    </td>
                    <td
                        v-if="hasDeleteContactLink"
                        class="w-[10%] font-medium p-3"
                        id="body_Löschen"
                    >
                        <button
                            @click="props.deleteMethod?.(contact.contactId ?? 0)"
                            class="w-full"
                            data-cy="delete_button"
                        >
                            <img
                                src="@/assets/images/Trash.png"
                                alt="Del"
                                class="lg:w-[35px] w-[20px] mx-auto"
                            />
                        </button>
                    </td>
                </tr>
                <!-- <tr>
                    <td colspan="7" class="font-medium p-3">
                        <button @click="props.load({ done: () => {} })" class="w-full">
                            <img src='@/assets/images/Arrow_down.png' alt='Del' class="lg:w-[45px] w-[30px] mx-auto">
                        </button>
                    </td>
                </tr> -->
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
    import { Contact } from '@/model/types'
    import useContactStore from '@/utils/useContactStore'
    import { computed } from 'vue'

    const { contactsLinks } = useContactStore()
    console.log(contactsLinks.value)

    const hasUpdateContactLink = computed(() =>
        contactsLinks.value.some((link) => link.rel === 'contact/update')
    )
    const hasCreateContactLink = computed(() =>
        contactsLinks.value.some((link) => link.rel === 'contact/create')
    )
    const hasDeleteContactLink = computed(() =>
        contactsLinks.value.some((link) => link.rel === 'contact/delete')
    )

    const props = defineProps<{
        deleteMethod?: (contactId: number) => void
        contacts: Contact[]
        selectMethod?: (contact: Contact) => void
        duplicateMethod?: (contact: Contact) => void
        load?: Function
        contactsCount?: number
    }>()
</script>
